var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({class:[_vm.color, 'primary--text rounded-lg'],attrs:{"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }